




























































































































































































































































import Vue from 'vue';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { iconsMixin } from '@/mixins/icons';
import { truckloadQuoteMixin } from '@/mixins/truckloadQuote';

import TruckQuoteOriginInformation from './truckload-quote-email/OriginInformation.vue';
import TruckQuoteDestinationInformation from './truckload-quote-email/DestinationInformation.vue';
import TruckQuoteContactInformation from './truckload-quote-email/ContactInformation.vue';
import TruckQuoteServiceInformation from './truckload-quote-email/ServiceInformation.vue';
import TruckQuoteCommodityInformation from './truckload-quote-email/CommodityInformation.vue';

import { SavePendingOrderResponse } from '@/models/shipments/addOrEdit/responses/SavePendingOrderResponse';

import countryService from '@/services/CountryService';
import locationsService from '@/services/LocationsService';
import DropdownOption from '@/models/misc/DropdownOption';
import equipmentTypeService from '@/services/EquipmentTypeService';
import pendingOrderService from '@/services/PendingOrderService';
import accountsService from '@/services/AccountsService';

export default Vue.extend<any, any, any, any>({
  name: 'truckload-quote',
  mixins: [breakpointsMixin, authMixin, iconsMixin, truckloadQuoteMixin],
  components: {
    TruckQuoteOriginInformation,
    TruckQuoteDestinationInformation,
    TruckQuoteContactInformation,
    TruckQuoteServiceInformation,
    TruckQuoteCommodityInformation
  },
  data() {
    return {
      countriesDll: [] as DropdownOption[],
      origStatesDdl: [] as DropdownOption[],
      contactInfo: {
        name: '',
        company: '',
        phone: '',
        email: '',
      },
      originInfo: {
        location: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        contactName: '',
        contactPhone: '',
        country: 'USA',
        saveToAddressBook: false,
      },
      destinationInfo: {
        location: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        contactName: '',
        contactPhone: '',
        country: 'USA',
        saveToAddressBook: false,
      },
      serviceInfo: {
        pickupDate: null,
        deliveryDate: null,
        equipmentType: null,
        flatbedWithTarps: false,
        hazardousMaterials: false,
        perishableGoods: false,
        hazardousUN: '',
        hazardousClass: '',
        declaredValue: null,
        insuredValue: null,
        perishableTemp: null,
      },
      equipmentTypesDdl: [] as DropdownOption[],
      commodities: [],
      additionalNotes: '',
      submitting: false,
      showSuccessDialog: false,
      unitsOfMeasure: 'standard',
      showClearConfirmDialog: false,
      showCommodityError: false,
      missingFields: [] as string[],
      showContactError: false,
      contactMissingFields: [] as string[],
      showOriginError: false,
      originMissingFields: [] as string[],
      showDestinationError: false,
      destinationMissingFields: [],
      showServiceError: false,
      serviceMissingFields: [] as string[],
      selectedHazardousClass: null,
      pendingOrderId: null as string | null,
      showErrorDialog: false,
      errorMessage: null as string | null,
      snackbarText: null as string | null,
      showOrigAddressBookPopup: false,
      showDestAddressBookPopup: false,
    };
  },
  computed: {
    pickupMinDate(): string {
      return new Date().toISOString().substr(0, 10);
    },
    pickupMaxDate(): string {
      const maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() + 1);
      return maxDate.toISOString().substr(0, 10);
    },
    deliveryMinDate(): string {
      // Delivery date should be at least the pickup date or today
      return (
        this.serviceInfo.pickupDate || new Date().toISOString().substr(0, 10)
      );
    },
    deliveryMaxDate(): string {
      const maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() + 1);
      return maxDate.toISOString().substr(0, 10);
    },
    isFormValid(): boolean {
      return (
        !!this.contactInfo.name &&
        !!this.contactInfo.company &&
        !!this.contactInfo.phone &&
        !!this.contactInfo.email &&
        !!this.originInfo.location &&
        !!this.originInfo.address &&
        !!this.originInfo.city &&
        !!this.originInfo.state &&
        !!this.originInfo.zipCode &&
        !!this.originInfo.country &&
        !!this.destinationInfo.location &&
        !!this.destinationInfo.address &&
        !!this.destinationInfo.city &&
        !!this.destinationInfo.state &&
        !!this.destinationInfo.zipCode &&
        !!this.destinationInfo.country &&
        !!this.serviceInfo.pickupDate &&
        !!this.serviceInfo.equipmentType &&
        this.commodities.length > 0
      );
    },
    isCommodityValid(): boolean {
      const c = this.commodityInfo;
      return !!(
        c.name &&
        c.pieces &&
        c.weight &&
        c.length &&
        c.width &&
        c.height
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    pickupDateChanged(date) {
      // if pickup date changes and is after delivery date, reset delivery date
      if (
        this.serviceInfo.deliveryDate &&
        date > this.serviceInfo.deliveryDate
      ) {
        this.serviceInfo.deliveryDate = null;
      }
    },
    deliveryDateChanged(date) {
      // additional logic for delivery date changes if needed
      console.log('Delivery date changed:', date);
    },
    init() {
      this.countriesDll = countryService.getAll();
      this.countryOrigChanged({ value: 'USA' });

      // set default contact info
      this.contactInfo.name = this.displayFullName;
      this.contactInfo.company = this.user.company;
      this.contactInfo.email = this.displayEmail;
      this.patchPhoneNumberFromUserProfile(this.user.accountId, this.user.userId);

      equipmentTypeService.search(this.user.accountId, this.user.userId, 6)
        .then(response => {
          this.equipmentTypesDdl = response.map(type => new DropdownOption(type.description, type.id));
        })
        .catch(error => {
          console.error('Error fetching equipment types:', error);
        });
    },
    countryOrigChanged(selected) {
      if (selected) {
        locationsService.getListOfStates(selected.value).then((x) => {
          this.origStatesDdl = x.map(this.mapStates);
        });
      }
    },
    mapStates(state) {
      return new DropdownOption(state.name, state.id);
    },
    isValidPhoneNumber(phone: string): boolean {
      // matches (XXX) XXX-XXXX format
      const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
      return phoneRegex.test(phone);
    },
    isValidEmail(email: string): boolean {
      // basic email validation regex
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    isValidZipCode(zipCode: string, country: string): boolean {
      if (!zipCode) return false;

      if (country === 'USA') {
        // USA zip code format: 5 digits or 5+4 digits
        const usaZipRegex = /^\d{5}(-\d{4})?$/;
        return usaZipRegex.test(zipCode);
      } else if (country === 'CAN') {
        // Canadian postal code format: A1A 1A1
        const canZipRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        return canZipRegex.test(zipCode);
      }

      return true; // for other countries, accept any format
    },
    formatZipCode(zipCode: string, country: string): string {
      if (!zipCode) return zipCode;

      if (country === 'USA') {
        // remove all non-digit characters
        const cleaned = zipCode.replace(/\D/g, '');
        if (cleaned.length === 9) {
          return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
        }
        return cleaned.slice(0, 5);
      } else if (country === 'CAN') {
        // remove all non-alphanumeric characters and convert to uppercase
        const cleaned = zipCode.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        if (cleaned.length === 6) {
          return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
        }
        return cleaned;
      }

      return zipCode;
    },
    formatPhoneNumber(phone: string): string {
      // remove all non-digit characters
      const cleaned = phone.replace(/\D/g, '');

      // check if we have enough digits
      if (cleaned.length !== 10) return phone;

      // format as (XXX) XXX-XXXX
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6
      )}`;
    },
    submitQuoteRequest() {
      // validate all blocks
      const isContactValid = this.$refs.contactInfo?.validateBlock?.() ?? true;
      const isOriginValid = this.$refs.originInfo?.validateBlock?.() ?? true;
      const isDestinationValid = this.$refs.destinationInfo?.validateBlock?.() ?? true;
      const isServiceValid = this.$refs.serviceInfo?.validateBlock?.() ?? true;
      const isCommodityValid = this.$refs.commodityInfo?.validateCommodityBlock?.() ?? true;
      if (!isContactValid || !isOriginValid || !isDestinationValid || !isServiceValid || !isCommodityValid) {
        this.scrollToFirstError();
        return;
      }

      this.submitting = true;
      const saveShipmentRequest = this.mapToSaveShipmentRequest(this.user.userId, this.user.accountId);

      // submit the pending order request
      pendingOrderService.create(saveShipmentRequest)
        .then((response: SavePendingOrderResponse) => {
          console.log('Pending order created:', response);
          if (response.success) {
            this.pendingOrderId = response.orderId;
            return this.submitTruckloadQuote(response.orderId);
          } else {
            throw new Error('Error creating pending order: ' + response.error);
          }
        })
        .then((quoteResponse) => {
          this.submitting = false;
          if (quoteResponse.success) {
            this.showSuccessDialog = true;
          } else {
            this.errorMessage = 'Error submitting truckload quote request';
            this.showErrorDialog = true;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          this.submitting = false;
          this.errorMessage = error.message || 'An error occurred while processing your request. Please try again.';
          this.showErrorDialog = true;
        });
    },
    closeSuccessDialog() {
      this.showSuccessDialog = false;
      this.$router.push({
        path: '/customer/spot-market',
        query: { highlightOrderId: this.pendingOrderId }
      });
    },
    closeErrorDialog() {
      this.showErrorDialog = false;
      this.errorMessage = null;
    },
    onClearClick() {
      this.showClearConfirmDialog = true;
    },
    cancelClear() {
      this.showClearConfirmDialog = false;
    },
    confirmClear() {
      this.showClearConfirmDialog = false;
      window.location.reload();
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        const errorAlerts = document.querySelectorAll('.v-alert');
        if (errorAlerts.length > 0) {
          errorAlerts[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      });
    },
    copyOrderId() {
      if (this.pendingOrderId) {
        navigator.clipboard.writeText(this.pendingOrderId).then(() => {
          this.$toast.show(`Pending Order ID ${this.pendingOrderId} copied to clipboard!`);
        }).catch(err => {
          console.error('Failed to copy order ID: ', err);
          this.$toast.show('Failed to copy Order ID', { type: 'error' });
        });
      }
    },
    origLocationFromAddressBookSelected(location) {
      this.originInfo.location = location.company;
      this.originInfo.address = location.address1;
      this.originInfo.city = location.city;
      this.originInfo.state = location.state;
      this.originInfo.zipCode = location.postalCode;
      this.originInfo.country = location.country;
      this.originInfo.contactName = location.contact;
      this.originInfo.contactPhone = location.phone;

      this.showOrigAddressBookPopup = false;
    },
    destLocationFromAddressBookSelected(location) {
      this.destinationInfo.location = location.company;
      this.destinationInfo.address = location.address1;
      this.destinationInfo.city = location.city;
      this.destinationInfo.state = location.state;
      this.destinationInfo.zipCode = location.postalCode;
      this.destinationInfo.country = location.country;
      this.destinationInfo.contactName = location.contact;
      this.destinationInfo.contactPhone = location.phone;

      this.showDestAddressBookPopup = false;
    },
    patchPhoneNumberFromUserProfile(accountId, userId) {
      accountsService.getUser(accountId, userId)
        .then(data => {
          this.contactInfo.phone = data.phone;
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
        });
    },
  },
  watch: {
    contactInfo: {
      handler(newVal) {
        if (this.showContactError) {
          // update missing fields list based on current state
          this.contactMissingFields = [];

          if (!newVal.name) this.contactMissingFields.push('Name');
          if (!newVal.company) this.contactMissingFields.push('Company');

          if (!newVal.phone) {
            this.contactMissingFields.push('Phone');
          } else if (!this.isValidPhoneNumber(newVal.phone)) {
            this.contactMissingFields.push(
              'Phone (must be in format (XXX) XXX-XXXX)'
            );
          }

          if (!newVal.email) {
            this.contactMissingFields.push('Email');
          } else if (!this.isValidEmail(newVal.email)) {
            this.contactMissingFields.push(
              'Email (must be a valid email address)'
            );
          }

          // hide error if all fields are valid
          if (this.contactMissingFields.length === 0) {
            this.showContactError = false;
          }
        }
      },
      deep: true,
    },
    originInfo: {
      handler(newVal) {
        if (this.showOriginError) {
          // update missing fields list based on current state
          this.originMissingFields = [];

          if (!newVal.location) this.originMissingFields.push('Shipper Name');
          if (!newVal.contactName)
            this.originMissingFields.push('Contact Name');
          if (!newVal.country) this.originMissingFields.push('Country');
          if (!newVal.address) this.originMissingFields.push('Address');
          if (!newVal.city) this.originMissingFields.push('City');
          if (!newVal.state) this.originMissingFields.push('State/Province');

          if (!newVal.zipCode) {
            this.originMissingFields.push('Zip/Postal Code');
          } else if (!this.isValidZipCode(newVal.zipCode, newVal.country)) {
            if (newVal.country === 'USA') {
              this.originMissingFields.push(
                'Zip Code (must be in format 12345 or 12345-6789)'
              );
            } else if (newVal.country === 'CAN') {
              this.originMissingFields.push(
                'Postal Code (must be in format A1A 1A1)'
              );
            }
          }

          if (
            newVal.contactPhone &&
            !this.isValidPhoneNumber(newVal.contactPhone)
          ) {
            this.originMissingFields.push(
              'Contact Phone (must be in format (XXX) XXX-XXXX)'
            );
          }

          // hide error if all fields are valid
          if (this.originMissingFields.length === 0) {
            this.showOriginError = false;
          }
        }
      },
      deep: true,
    },
    destinationInfo: {
      handler(newVal) {
        if (this.showDestinationError) {
          // update missing fields list based on current state
          this.destinationMissingFields = [];

          if (!newVal.location)
            this.destinationMissingFields.push('Receiver Name');
          if (!newVal.contactName)
            this.destinationMissingFields.push('Contact Name');
          if (!newVal.country) this.destinationMissingFields.push('Country');
          if (!newVal.address) this.destinationMissingFields.push('Address');
          if (!newVal.city) this.destinationMissingFields.push('City');
          if (!newVal.state)
            this.destinationMissingFields.push('State/Province');

          if (!newVal.zipCode) {
            this.destinationMissingFields.push('Zip/Postal Code');
          } else if (!this.isValidZipCode(newVal.zipCode, newVal.country)) {
            if (newVal.country === 'USA') {
              this.destinationMissingFields.push(
                'Zip Code (must be in format 12345 or 12345-6789)'
              );
            } else if (newVal.country === 'CAN') {
              this.destinationMissingFields.push(
                'Postal Code (must be in format A1A 1A1)'
              );
            }
          }

          if (
            newVal.contactPhone &&
            !this.isValidPhoneNumber(newVal.contactPhone)
          ) {
            this.destinationMissingFields.push(
              'Contact Phone (must be in format (XXX) XXX-XXXX)'
            );
          }

          // hide error if all fields are valid
          if (this.destinationMissingFields.length === 0) {
            this.showDestinationError = false;
          }
        }
      },
      deep: true,
    },
    'serviceInfo.pickupDate': {
      handler(newVal) {
        if (this.showServiceError) {
          this.serviceMissingFields = [];
          if (!newVal) {
            this.serviceMissingFields.push('Pickup Date');
          } else {
            this.showServiceError = false;
          }
        }
      },
    },
    commodities: {
      handler(newVal) {
        if (this.showCommodityError) {
          if (newVal.length > 0) {
            this.showCommodityError = false;
            this.missingFields = [];
          } else {
            this.showCommodityError = true;
            this.missingFields = ['At least one commodity must be added'];
          }
        }
        if (!this.showCommodityError && newVal.length === 0) {
          this.showCommodityError = true;
          this.missingFields = ['At least one commodity must be added'];
        }
      },
      deep: true,
    },
  },
});
